'use client';

import React from 'react';
import { Chip, Button } from '@heroui/react';
import { Typography } from '../../../../components';
import { useTranslations } from '../../../../contexts/translation.context';
import { StatusCellProps } from '../types';

const StatusCell: React.FC<StatusCellProps> = ({ bill, onPayBill }) => {
  const { t } = useTranslations();

  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'in_pending':
        return { dot: 'bg-partner', label: t('client.revshare.bills.status.in_pending') };
      case 'paid':
        return { dot: 'bg-success', label: t('client.revshare.bills.status.paid') };
      default:
        return { dot: 'bg-gray-600', label: status };
    }
  };

  const statusConfig = getStatusConfig(bill.status);

  const handlePayClick = () => {
    if (onPayBill) {
      onPayBill(bill._id);
    }
  };

  return (
    <div className="flex flex-col items-start gap-2">
      <Chip
        className="bg-gray-100 text-gray-900"
        classNames={{
          base: 'h-6 px-2 py-1 gap-1',
        }}
        size="sm"
        startContent={<div className={`w-2 h-2 rounded-full ${statusConfig.dot}`} />}
      >
        <Typography variant="body3" className="text-gray-900">
          {statusConfig.label}
        </Typography>
      </Chip>

      {bill.status === 'in_pending' && onPayBill && (
        <Button
          size="sm"
          className="h-7 px-3 rounded-2 bg-[#F0EBFA] text-primary text-xs font-medium min-w-0"
          onPress={handlePayClick}
        >
          {t('client.revshare.bills.status.payFromBalance')}
        </Button>
      )}
    </div>
  );
};

export default StatusCell;
